export default {
  wordboards: [],
  count: 0,
  lastFilter: {},
};



// WEBPACK FOOTER //
// ./src/store/modules/wordboard/state.js